module.exports = __webpack_public_path__ + "img/trufence_diagram_step2.1e771d35.svg";